<template>
    <section class="panel kb-feedback-panel">
        <div class="panel-body">
            <div
                class="simple-feedback"
                v-if="!simpleFeedbackSubmitted">
                <h2>Was this page helpful?</h2>
                <form @submit.prevent="submitSimpleFeedback">
                    <fieldset :disabled="submitting">
                        <button
                            class="btn btn-default"
                            type="submit"
                            @click="experience = 'positive'">
                            Yes, it's perfect!
                        </button>
                        <button
                            class="btn btn-default"
                            type="submit"
                            @click="experience = 'negative'">
                            No, it could be better.
                        </button>
                    </fieldset>
                </form>
            </div>

            <div
                class="full-feedback"
                v-else-if="!fullFeedbackSubmitted">
                <h2>Thanks for the feedback!</h2>
                <form @submit.prevent="submitFullFeedback">
                    <fieldset :disabled="submitting">
                        <div class="form-group">
                            <label>Additional feedback</label>
                            <textarea
                                class="form-control"
                                placeholder="Care to elaborate on what you did or didn't like about this page?"
                                cols="50"
                                rows="3"
                                ref="fullFeedback"
                                v-model="text">
                            </textarea>
                        </div>
                        <div class="form-group">
                            <button
                                class="btn btn-success"
                                type="submit"
                                :disabled="!text">
                                Submit
                            </button>
                            <button
                                class="btn btn-default"
                                @click="closeFullFeedback">
                                Close
                            </button>
                        </div>
                    </fieldset>
                </form>
            </div>

            <div
                class="done-feedback"
                v-else>
                <h2>Thank you! Your feedback has been saved.</h2>
            </div>
        </div>
    </section>
</template>

<script>
    import Kb from '../../services/knowledge-base';
    import toastr from 'toastr';

    export default {
        name: 'kb-feedback',

        props: [],

        data() {
            return {
                feedbackId: null,
                experience: null,
                text: '',

                submitting: false,
                simpleFeedbackSubmitted: false,
                fullFeedbackSubmitted: false,
            };
        },

        methods: {
            getUserId() {
                return parseInt(localStorage.user_id);
            },

            async submitSimpleFeedback() {
                if (!this.experience) {
                    return;
                }

                try {
                    this.submitting = true;
                    const {id} = await Kb.createFeedback({
                        createdBy:    this.getUserId(),
                        urlPath:        this.$route.fullPath,
                        experience: this.experience,
                    });
                    this.feedbackId = id;
                    this.simpleFeedbackSubmitted = true;

                } catch (err) {
                    console.log('Error saving kb feedback:', err);
                    toastr.error('There was an error while saving the feedback. Please try again later.');
                    return;

                } finally {
                    this.submitting = false;
                }

                this.$nextTick(() => {
                    this.$refs.fullFeedback.focus();
                });
            },

            async submitFullFeedback() {
                if (!this.text) {
                    return;
                }

                try {
                    this.submitting = true;
                    await Kb.updateFeedback(this.feedbackId, { text: this.text });
                    this.fullFeedbackSubmitted = true;

                } catch (err) {
                    console.log('Error saving kb feedback:', err);
                    toastr.error('There was an error while saving the feedback. Please try again later.');
                    return;

                } finally {
                    this.submitting = false;
                }
            },

            closeFullFeedback() {
                this.fullFeedbackSubmitted = true;
            },
        }
    }
</script>

<style lang="scss" scoped>
    .clear-button {
        border: none;
        background: none;
    }

    .kb-feedback-panel {
        .panel-body {
            padding: 40px 20px;
        }

        h2 {
            font-size: 20px;
            text-align: center;
            margin: 0 0 30px 0;
        }

        .simple-feedback {
            text-align: center;
        }

        .full-feedback {
            width: 80%;
            max-width: 600px;
            margin: 0 auto;
        }

        .done-feedback {
            h2 {
                margin: 0;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// KbFeedback.vue?69089d63